import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list", "select", "empty"]

  connect() {
    this.options = Array.from(this.selectTarget.options).map((option) => ({
      value: option.value,
      label: option.textContent.trim(),
      disabled: option.disabled,
      searchable: option.textContent.trim().toLowerCase()
    }))

    this.syncInput()
    this.close = this.close.bind(this)
    document.addEventListener("click", this.close)
  }

  disconnect() {
    document.removeEventListener("click", this.close)
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    const options = this.options.filter((option) => {
      if (option.disabled || option.value === "") return false
      return option.searchable.includes(query)
    })

    this.render(options)
    this.open()
  }

  focus() {
    this.filter()
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.hide()
      return
    }

    if (event.key !== "Enter") return

    const firstButton = this.listTarget.querySelector("button")
    if (!firstButton) return

    event.preventDefault()
    firstButton.click()
  }

  choose(event) {
    const value = event.currentTarget.dataset.value
    const option = this.options.find((item) => item.value === value)
    if (!option) return

    this.selectTarget.value = option.value
    this.inputTarget.value = option.label
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.hide()
  }

  clear() {
    if (this.inputTarget.value.trim() !== "") return
  }

  close(event) {
    if (this.element.contains(event.target)) return

    this.hide()
    this.syncInput()
  }

  syncInput() {
    const selected = this.options.find((option) => option.value === this.selectTarget.value)
    this.inputTarget.value = selected && selected.value !== "" ? selected.label : ""
  }

  render(options) {
    this.listTarget.innerHTML = options.map((option) => `
      <button
        type="button"
        class="searchable-select__option ${option.value === this.selectTarget.value ? "is-selected" : ""}"
        data-action="click->searchable-select#choose"
        data-value="${this.escapeAttribute(option.value)}"
      >
        ${this.escapeHtml(option.label)}
      </button>
    `).join("")

    this.emptyTarget.classList.toggle("d-none", options.length > 0)
  }

  open() {
    this.element.classList.add("is-open")
  }

  hide() {
    this.element.classList.remove("is-open")
  }

  escapeHtml(value) {
    return value.replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "\"": "&quot;",
      "'": "&#39;"
    })[char])
  }

  escapeAttribute(value) {
    return this.escapeHtml(value)
  }
}
